import { render } from "./SectionCollapse.vue?vue&type=template&id=bc04e5c8&scoped=true"
import script from "./SectionCollapse.vue?vue&type=script&lang=js"
export * from "./SectionCollapse.vue?vue&type=script&lang=js"

import "./SectionCollapse.vue?vue&type=style&index=0&id=bc04e5c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc04e5c8"]])

export default __exports__